import { styled } from '@mui/material/styles';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

export const FilterContainer = styled(Paper)(({ theme }) => ({
  position: 'absolute',
  top: '150px',
  right: '5%',
  zIndex: 1000,
  width: '500px',
  marginTop: 1,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 1,
}));

export const FilterHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(2),
}));

export const FilterSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(1, 2),
}));

export const FilterCategory = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(1),
  marginBottom: theme.spacing(1),
  fontWeight: 600,
  borderRadius: 4,
  '&: hover': {
    cursor: 'pointer',
    backgroundColor: theme.palette.action.hover,
  },
}));

export const FilterFooter = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: theme.spacing(1),
  padding: theme.spacing(2),
}));
